import { Button, Divider, Menu } from "antd"
import * as COMMONS from "common/common"
import React from "react"
import {
  FaChevronLeft,
  FaChevronRight,
  FaUserCircle,
  FaArchive,
  FaShippingFast,
} from "react-icons/fa"
import { BsFillGearFill } from "react-icons/bs"
import { useLocation, useNavigate } from "react-router-dom"

const { SubMenu } = Menu

const rootSubmenuKeys = ["deliveries", "products", "members", "settings"]

const Sidebar = (props) => {
  const { isHamburger, isCollapsed, collapseToggle } = props
  const location = useLocation()
  const navigate = useNavigate()

  const [openKeys, setOpenKeys] = React.useState([])

  const getCurrentPathWithoutLastPart = () => {
    return location.pathname.slice(0, location.pathname.lastIndexOf("/")) !== ""
      ? location.pathname.slice(0, location.pathname.lastIndexOf("/"))
      : location.pathname
  }

  const handleClick = (event) => {
    switch (event.key) {
      case COMMONS.ADMIN_SHIPMENTS_ROUTE:
        navigate(COMMONS.ADMIN_SHIPMENTS_ROUTE)
        break
      case COMMONS.ADMIN_RESERVATION_LIST_ROUTE:
        navigate(COMMONS.ADMIN_RESERVATION_LIST_ROUTE)
        break
      case COMMONS.ADMIN_PURCHASES_ROUTE:
        navigate(COMMONS.ADMIN_PURCHASES_ROUTE)
        break
      case COMMONS.ADMIN_PRODUCTS_ROUTE:
        navigate(COMMONS.ADMIN_PRODUCTS_ROUTE)
        break
      case COMMONS.ADMIN_PRODUCTS_SORT_ROUTE:
        navigate(COMMONS.ADMIN_PRODUCTS_SORT_ROUTE)
        break
      case COMMONS.ADMIN_PRODUCTS_STOCK_ROUTE:
        navigate(COMMONS.ADMIN_PRODUCTS_STOCK_ROUTE)
        break
      case COMMONS.ADMIN_CUSTOMERS_ROUTE:
        navigate(COMMONS.ADMIN_CUSTOMERS_ROUTE)
        break
      case COMMONS.ADMIN_NOTIFICATION_SETTINGS_ROUTE:
        navigate(COMMONS.ADMIN_NOTIFICATION_SETTINGS_ROUTE)
        break
      case COMMONS.ADMIN_PICKUP_SETTINGS_ROUTE:
        navigate(COMMONS.ADMIN_PICKUP_SETTINGS_ROUTE)
        break
      case COMMONS.ADMIN_SHIPMENT_SETTINGS_ROUTE:
        navigate(COMMONS.ADMIN_SHIPMENT_SETTINGS_ROUTE)
        break
      case COMMONS.ADMIN_RICHMENU_SETTINGS_ROUTE:
        navigate(COMMONS.ADMIN_RICHMENU_SETTINGS_ROUTE)
        break
      case COMMONS.ADMIN_POINT_SETTINGS_ROUTE:
        navigate(COMMONS.ADMIN_POINT_SETTINGS_ROUTE)
        break
      case COMMONS.ADMIN_TAX_SETTINGS_ROUTE:
        navigate(COMMONS.ADMIN_TAX_SETTINGS_ROUTE)
        break
      case "collapse":
        collapseToggle()
        break
      default:
        break
    }

    if (isHamburger) collapseToggle()
  }

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }

  return (
    <div
      className="flex flex-col h-full"
      style={{ overflowX: "hidden", overflowY: "auto" }}
    >
      <div className="text-center h-6 px-4 mt-4">
        <p className={`font-bold ${isCollapsed ? "text-xs" : "text-base"}`}>
          {process.env.REACT_APP_SYSTEM_NAME}
        </p>
      </div>
      <Divider />
      <div className="flex-grow flex-shrink">
        <Menu
          onClick={handleClick}
          defaultSelectedKeys={[COMMONS.ADMIN_SHIPMENTS_ROUTE]}
          openKeys={openKeys}
          selectedKeys={[getCurrentPathWithoutLastPart()]}
          onOpenChange={onOpenChange}
          mode="inline"
        >
          <SubMenu
            key="deliveries"
            icon={<FaShippingFast className="text-xl leading-none" />}
            title="受注管理"
          >
            <Menu.Item key={COMMONS.ADMIN_SHIPMENTS_ROUTE}>配達一覧</Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_RESERVATION_LIST_ROUTE}>
              取置き一覧
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_PURCHASES_ROUTE}>
              処理中・期限切れ
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="products"
            icon={<FaArchive className="text-xl leading-none" />}
            title="商品管理"
          >
            <Menu.Item key={COMMONS.ADMIN_PRODUCTS_ROUTE}>商品一覧</Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_PRODUCTS_SORT_ROUTE}>
              商品表示順
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_PRODUCTS_STOCK_ROUTE}>
              在庫状況
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="members"
            icon={<FaUserCircle className="text-xl leading-none" />}
            title="会員管理"
          >
            <Menu.Item key={COMMONS.ADMIN_CUSTOMERS_ROUTE}>会員一覧</Menu.Item>
          </SubMenu>
          <SubMenu
            key="settings"
            icon={<BsFillGearFill className="text-xl leading-none" />}
            title="設定"
          >
            <Menu.Item key={COMMONS.ADMIN_NOTIFICATION_SETTINGS_ROUTE}>
              自動通知設定
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_PICKUP_SETTINGS_ROUTE}>
              店舗受け取り設定
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_SHIPMENT_SETTINGS_ROUTE}>
              配達設定
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_POINT_SETTINGS_ROUTE}>
              ポイント設定
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_RICHMENU_SETTINGS_ROUTE}>
              リッチメニュー設定
            </Menu.Item>
            <Menu.Item key={COMMONS.ADMIN_TAX_SETTINGS_ROUTE}>
              税率設定
            </Menu.Item>
          </SubMenu>
        </Menu>
      </div>
      <Button type="primary" className="rounded-none" onClick={collapseToggle}>
        {isCollapsed ? (
          <FaChevronRight className="text-xl leading-none" />
        ) : (
          <FaChevronLeft className="text-xl leading-none" />
        )}
      </Button>
    </div>
  )
}

export default Sidebar
